// Resolve a bilingual field from an article/bet object for the given language.
// Falls back: requested lang -> nl -> en -> legacy single field -> "".
export function loc(obj, field, lang) {
  if (!obj) return "";
  const primary = obj[`${field}_${lang}`];
  if (primary) return primary;
  const nl = obj[`${field}_nl`];
  const en = obj[`${field}_en`];
  return primary || nl || en || obj[field] || "";
}
